import { Store, Module, ActionContext } from "vuex";
import ListModule from "./list-module";
import ListState from "./list-state";
import PurchaseOrder from "../entities/purchase-order";
import Ajax from "../../lib/ajax";
import PageResult from "@/store/entities/page-result";
import Ref from "../entities/ref";
import PurchaseOrderLine from "../entities/purchase-order-line";
import PurchaseOrderForPrinter from "../entities/purchase-order-for-printer";
import ProductForSelect from "../entities/products/product-for-select";

interface PurchaseOrderState extends ListState<PurchaseOrder> {
  editPurchaseOrder: PurchaseOrder;
  permissions: Array<string>;
  statuses: Array<Ref>;
  poItems: Array<PurchaseOrderLine>;
  viewPurchaseOrder: PurchaseOrder;
  purchaseOrderForPrinter: PurchaseOrderForPrinter;
}
class PurchaseOrderModule extends ListModule<
  PurchaseOrderState,
  any,
  PurchaseOrder
> {
  state = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    list: new Array<PurchaseOrder>(),
    loading: false,
    editPurchaseOrder: new PurchaseOrder(),
    permissions: new Array<string>(),
    statuses: new Array<Ref>(),
    poItems: new Array<PurchaseOrderLine>(),
    viewPurchaseOrder: new PurchaseOrder(),
    purchaseOrderForPrinter: new PurchaseOrderForPrinter(),
  };
  actions = {
    async getAll(
      context: ActionContext<PurchaseOrderState, any>,
      payload: any
    ) {
      context.state.loading = true;
      let reponse = await Ajax.get("/api/services/app/Po/GetAll", {
        params: payload.data,
      });
      context.state.loading = false;
      let page = reponse.data.result as PageResult<PurchaseOrder>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },
    async create(
      context: ActionContext<PurchaseOrderState, any>,
      payload: any
    ) {
      await Ajax.post("/api/services/app/Po/Create", payload.data);
    },
    async update(
      context: ActionContext<PurchaseOrderState, any>,
      payload: any
    ) {
      await Ajax.put("/api/services/app/Po/Update", payload.data);
    },
    async delete(
      context: ActionContext<PurchaseOrderState, any>,
      payload: any
    ) {
      await Ajax.delete("/api/services/app/Po/Delete?Id=" + payload.data.id);
    },
    async get(context: ActionContext<PurchaseOrderState, any>, payload: any) {
      let reponse = await Ajax.get("/api/services/app/Po/Get?Id=" + payload.id);
      return reponse.data.result as PurchaseOrder;
    },
    async getAllPermissions(context: ActionContext<PurchaseOrderState, any>) {
      let reponse = await Ajax.get("/api/services/app/Po/getAllPermissions");
      context.state.permissions = reponse.data.result.items;
    },
    async getListStatusForSelect(
      context: ActionContext<PurchaseOrderState, any>,
      payload: any
    ) {
      let reponse = await Ajax.get("/api/services/app/Po/GetRefsForSelect", {
        params: payload.data,
      });
      context.state.statuses = reponse.data.result.items as Ref[];
    },
    async getPoInfoByCode(
      context: ActionContext<PurchaseOrderState, any>,
      payload: any
    ) {
      let reponse = await Ajax.get(
        "/api/services/app/Po/getPoInfoByCode?code=" + payload.data.code
      );
      return reponse.data.result as PurchaseOrder;
    },
    async getPoLinesInfoByPoId(
      context: ActionContext<PurchaseOrderState, any>,
      payload: any
    ) {
      let reponse = await Ajax.get(
        "/api/services/app/Po/GetPoLinesInfoByPoId?code=" + payload.data.code
      );
      return reponse.data.result;
    },
    async getPoInfoForUpdateByCode(
      context: ActionContext<PurchaseOrderState, any>,
      payload: any
    ) {
      let reponse = await Ajax.get(
        "/api/services/app/Po/GetPoInfoForUpdateByCode",
        { params: payload.data }
      );
      return reponse.data.result;
    },
    async finish(
      context: ActionContext<PurchaseOrderState, any>,
      payload: any
    ) {
      context.state.loading = true;
      await Ajax.put("/api/services/app/Po/Finish/" + payload.data);
      context.state.loading = false;
    },
    async getDataPoForPrinter(
      context: ActionContext<PurchaseOrderState, any>,
      payload: any
    ) {
      var url = "/api/services/app/Po/Printer/" + payload.data.code;
      const {
        data: { result },
      } = await Ajax.get(url);
      context.state.purchaseOrderForPrinter = result as PurchaseOrderForPrinter;
    },
    async createPoCheckIn(
      context: ActionContext<PurchaseOrderState, any>,
      payload: any
    ) {
      var {
        data: { result },
      } = await Ajax.post(
        "/api/services/app/PurchaseOrderCheckIn/Create",
        payload.data
      );
      return result;
    },
    async uploadDocumentPoMedia(
      context: ActionContext<PurchaseOrderState, any>,
      data: any
    ) {
      const {
        data: { result },
      } = await Ajax.post(
        "/api/services/app/PurchaseOrderCheckIn/UploadDocumentPoMedia",
        data
      );
      return result;
    },
    async getPoCheckIn(
      context: ActionContext<PurchaseOrderState, any>,
      payload: any
    ) {
      let reponse = await Ajax.get(
        "/api/services/app/PurchaseOrderCheckIn/View?code=" + payload.data.code
      );
      return reponse.data.result;
    },
    async getPoCheckInsByPo(
      context: ActionContext<PurchaseOrderState, any>,
      payload: any
    ) {
      let {
        data: { result },
      } = await Ajax.get(
        "/api/services/app/PurchaseOrderCheckIn/GetPoCheckInsByPo?poCode=" +
          payload.data.poCode
      );
      return result;
    },
    async checkPoProductBySku(
      context: ActionContext<PurchaseOrderState, any>,
      payload: any
    ) {
      const {
        data: { result },
      } = await Ajax.get("/api/services/app/Po/CheckPoProductBySku", {
        params: payload.data,
      });
      return result;
    },
    async cancel(
      context: ActionContext<PurchaseOrderState, any>,
      payload: any
    ) {
      await Ajax.post("/api/services/app/Po/Cancel/", payload.data);
    },
    async searchPoProductForSelect(
      context: ActionContext<PurchaseOrderState, any>,
      payload: any
    ) {
      const {
        data: { result },
      } = await Ajax.get(
        "/api/services/app/Po/SearchPoProductForSelect/" +
          payload.data.poId +
          "/" +
          payload.data.keyWord
      );
      return result.items as ProductForSelect[];
    },
    async getListTypeForSelect(
      context: ActionContext<PurchaseOrderState, any>,
      payload: any
    ) {
      let reponse = await Ajax.get("/api/services/app/Po/GetRefsForSelect", {
        params: payload.data,
      });
      return reponse.data.result.items as Ref[];
    },
    async getListClientCentralTypeForSelect(
      context: ActionContext<PurchaseOrderState, any>
    ) {
      let reponse = await Ajax.get(
        "/api/services/app/Po/GetClientCentralCreatePoTypes"
      );
      return reponse.data.result;
    },
    async revertStatusToNew(
      context: ActionContext<PurchaseOrderState, any>,
      payload: any
    ) {
      context.state.loading = true;
      await Ajax.put(
        `/api/services/app/Po/${payload.data.id}/revert-status-to-new`
      );
      context.state.loading = false;
    },
    async sendPoReceiptMail(
      context: ActionContext<PurchaseOrderState, any>,
      payload: any
    ) {
      context.state.loading = true;
      await Ajax.put(
        `/api/services/app/Po/send-po-receipts-mail`,
        payload.data
      );
      context.state.loading = false;
    },
  };
  mutations = {
    setCurrentPage(state: PurchaseOrderState, page: number) {
      state.currentPage = page;
    },
    setPageSize(state: PurchaseOrderState, pagesize: number) {
      state.pageSize = pagesize;
    },
    edit(state: PurchaseOrderState, product: PurchaseOrder) {
      state.editPurchaseOrder = product;
    },
    view(state: PurchaseOrderState, purchaseOrder: PurchaseOrder) {
      state.viewPurchaseOrder = purchaseOrder;
    },
  };
}
const purchaseOrderModule = new PurchaseOrderModule();
export default purchaseOrderModule;
